<template>
  <div class="glpi-panel">
    <BRow class="g-3">
      <card-totalchamados class="d-none d-lg-flex" :status="1" :data="chamados['Nova']" :total="total" />
      <card-totalchamados class="d-none d-lg-flex" :status="2" :data="chamados['Pendente']" :total="total" />
      <card-totalchamados class="d-none d-lg-flex" :status="3" :data="chamados['Em Execução']" :total="total" />
      <card-totalchamados class="d-none d-lg-flex" :status="4" :data="chamados['Solucionada']" :total="total" />
      <card-totalchamados class="d-none d-lg-flex" :status="5" :data="chamados['Finalizada']" :total="total" />
      <card-totalchamados class="d-none d-lg-flex" :status="6" :data="avaliados" :total="total" />

      <BCol :xxl="'12'" :xl="'12'" :lg="'12'" :md="'12'" :sm="'12'" class="d-lg-none">
        <div class="mobile-slider">
          <div class="mobile-slider-track">
            <BButton size="sm" variant="light" class="slider-btn slider-btn-left" @click="prevSlide">
              <i class="ri-arrow-left-s-line"></i>
            </BButton>
            <BButton size="sm" variant="light" class="slider-btn slider-btn-right" @click="nextSlide">
              <i class="ri-arrow-right-s-line"></i>
            </BButton>
            <BRow class="g-0">
              <card-totalchamados
                v-if="statusSlides.length"
                :status="statusSlides[currentSlide].status"
                :data="statusSlides[currentSlide].data"
                :total="total"
                :slide-mode="true"
              />
            </BRow>
          </div>
        </div>
      </BCol>
    </BRow>

    <div v-if="total === 0" class="glpi-empty-state mt-3">
      <span class="glpi-empty-icon">
        <i class="ri-check-double-fill"></i>
      </span>
      <div>
        <h5 class="glpi-empty-title">Nenhum chamado encontrado</h5>
        <p class="glpi-empty-text mb-0">
          Quando você abrir um chamado, o panorama aparecerá aqui. Use o botão
          <b>+ Novo Chamado</b> para solicitar atendimento.
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.glpi-panel {
  display: flex;
  flex-direction: column;
}

.mobile-slider {
  width: 100%;
}

.mobile-slider-track {
  position: relative;
  overflow: visible;
}

.slider-btn {
  width: 32px;
  height: 32px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--bs-border-color);
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.16);
  z-index: 5;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  padding: 0;
}

.glpi-empty-state,
.glpi-highlight {
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
  padding: 1rem 1.05rem;
  background: rgba(255, 255, 255, 0.82);
  border: 1px solid #dbe5f0;
  border-radius: 1rem;
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.04);
}

.glpi-empty-icon,
.glpi-highlight-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 0.9rem;
  flex-shrink: 0;
  font-size: 1.15rem;
}

.glpi-empty-icon {
  color: #16a34a;
  background: #dcfce7;
}

.glpi-highlight-icon {
  color: #7c3aed;
  background: #ede9fe;
}

.glpi-empty-title,
.glpi-highlight-title {
  margin: 0 0 0.25rem;
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
}

.glpi-empty-text,
.glpi-highlight-text {
  font-size: 0.9rem;
  line-height: 1.6;
  color: #64748b;
}

.slider-btn-left {
  left: -1.45rem;
}

.slider-btn-right {
  right: -1.45rem;
}

[data-bs-theme="dark"] .slider-btn {
  background: rgba(15, 23, 42, 0.92);
  border-color: rgba(148, 163, 184, 0.2);
  color: #d7e3f4;
  box-shadow: 0 6px 16px rgba(2, 8, 20, 0.5);
}

[data-bs-theme="dark"] .glpi-empty-state,
[data-bs-theme="dark"] .glpi-highlight {
  background: rgba(15, 23, 42, 0.72);
  border-color: rgba(148, 163, 184, 0.16);
  box-shadow: 0 14px 28px rgba(2, 8, 20, 0.22);
}

[data-bs-theme="dark"] .glpi-empty-title,
[data-bs-theme="dark"] .glpi-highlight-title {
  color: #e5eefb;
}

[data-bs-theme="dark"] .glpi-empty-text,
[data-bs-theme="dark"] .glpi-highlight-text {
  color: #9fb0c9;
}

[data-bs-theme="dark"] .glpi-empty-icon {
  color: #4ade80;
  background: rgba(34, 197, 94, 0.16);
}

[data-bs-theme="dark"] .glpi-highlight-icon {
  color: #c084fc;
  background: rgba(139, 92, 246, 0.14);
}

@media (max-width: 768px) {
  .slider-btn-left {
    left: -1.15rem;
  }

  .slider-btn-right {
    right: -1.15rem;
  }
}
</style>

<script>
import axios from "axios";
import CardTotalchamados from "@/views/mirai/dashboard/cards/totalchamados.vue";
import { api } from "@/helpers/mirai/custom";

export default {
  name: "CardGlpi",
  components: { CardTotalchamados },
  data() {
    return {
      total: 0,
      avaliados: 0,
      user: JSON.parse(localStorage.getItem("userdata") || "{}"),
      userId: localStorage.getItem("userid"),
      chamados: {
        Nova: 0,
        Pendente: 0,
        Solucionada: 0,
        "Em Execução": 0,
        "Em revisão": 0,
        Finalizada: 0,
      },
      currentSlide: 0,
    };
  },
  computed: {
    statusSlides() {
      return [
        { status: 1, data: this.chamados.Nova || 0 },
        { status: 2, data: this.chamados.Pendente || 0 },
        { status: 3, data: this.chamados["Em Execução"] || 0 },
        { status: 4, data: this.chamados.Solucionada || 0 },
        { status: 5, data: this.chamados.Finalizada || 0 },
        { status: 6, data: this.avaliados || 0 },
      ];
    },
  },
  methods: {
    getAccountnamePesquisa() {
      return String(this.user?.usuario || this.userId || "").trim();
    },
    nextSlide() {
      if (!this.statusSlides.length) return;
      this.currentSlide = (this.currentSlide + 1) % this.statusSlides.length;
    },
    prevSlide() {
      if (!this.statusSlides.length) return;
      this.currentSlide = (this.currentSlide - 1 + this.statusSlides.length) % this.statusSlides.length;
    },
    async carregarTotalAvaliados({ limitePagina = 200, limiteMaximo = 5000 } = {}) {
      const accountname = this.getAccountnamePesquisa();
      if (!accountname) return 0;

      const tarefasAvaliadas = new Set();
      let offset = 0;
      let total = null;

      while (offset < limiteMaximo) {
        const result = await axios.get("/pesquisa/relatorio", {
          params: {
            accountname,
            limit: limitePagina,
            offset,
          },
        });

        const data = Array.isArray(result?.data?.data) ? result.data.data : [];
        if (data.length === 0) break;

        data.forEach((item) => {
          const contexto = String(item?.Pesquisa?.contexto || "chamado").trim().toLowerCase();
          const tarefaId = Number(item?.tarefa || item?.Tarefa?.id || item?.tarefaId || 0);

          if (contexto === "chamado" && Number.isFinite(tarefaId) && tarefaId > 0) {
            tarefasAvaliadas.add(tarefaId);
          }
        });

        const count = Number(result?.data?.filtered ?? result?.data?.total ?? result?.data?.count ?? 0);
        total = Number.isFinite(count) ? count : null;

        offset += data.length;
        if (data.length < limitePagina) break;
        if (total !== null && offset >= total) break;
      }

      return tarefasAvaliadas.size;
    },
    async getStart() {
      this.total = 0;
      this.avaliados = 0;
      this.currentSlide = 0;
      this.chamados = {
        Nova: 0,
        Pendente: 0,
        Solucionada: 0,
        "Em Execução": 0,
        "Em revisão": 0,
        Finalizada: 0,
      };

      try {
        const [chamados, avaliados] = await Promise.all([
          api.read(`tarefa?where={"accountname":"${this.userId}","finalidade":"chamado"}`),
          this.carregarTotalAvaliados(),
        ]);

        this.avaliados = Number(avaliados) || 0;

        if (chamados && chamados.length > 0) {
          this.total = chamados.length;
          chamados.forEach((chamado) => {
            if (typeof this.chamados[chamado.status] === "number") {
              this.chamados[chamado.status] += 1;
            }
          });
        }
      } catch (e) {
        console.error("Não foi possível carregar o panorama de chamados:", e?.response?.data || e);
      }
    },
  },
  mounted() {
    this.getStart();
  },
};
</script>
